module.exports = __webpack_public_path__ + "tj.4251237743e0424a5a74.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/tj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/tj.svg
// module chunks = styles